<section class="jumbotron e-bg-nosotros">
  <div class="container position-relative">
    <div class="text-white text-center">
      <h1 class="font-weight-bolder text-title-header">{{'about_us.about' | translate}}<br>
        {{'about_us.us' | translate}} </h1>
    </div>
  </div>
</section>
<section>
  <div class="container">
    <div class="my-5 w-75 m-auto text-center">
      <h3 class="text-blue-qaira font-weight-bold my-5">{{'about_us.born_init' | translate}}<span
          class="text-green-qaira">qAIRa</span>{{'about_us.born_end' | translate}}</h3>
      <p class="mt-3">{{'about_us.p1' | translate}}</p>
      <p>{{'about_us.p2' | translate}}</p>
    </div>
  </div>
</section>
<section>
  <div class="row w-100 m-0 text-center text-white">
    <div class="col-lg-6 col-12 bg-green-qaira px-custom py-5">
      <h4 class="font-weight-bolder">{{'about_us.our' | translate}} <span>{{'about_us.our_mission' | translate}}</span>
      </h4>
      <img class="icon-custom" src="../../../../assets/img/NOSOTROS/Sobre nosotros/Mision.svg" alt="" type="button"
        (click)="viewPopupMission()">
      <!-- <p>{{'about_us.mission' | translate}}</p> -->
    </div>
    <div class="col-lg-6 col-12 bg-green-light-qaira px-custom py-5">
      <h4 class="font-weight-bolder">{{'about_us.our' | translate}} <span>{{'about_us.our_vision' | translate}}</span>
      </h4>
      <img class="icon-custom" src="../../../../assets/img/NOSOTROS/Sobre nosotros/Vision.svg" alt="" type="button"
        (click)="viewPopupVision()">
      <!-- <p>{{'about_us.vision' | translate}}</p> -->
    </div>
  </div>
</section>
<section class="bg-white">
  <div class="container py-5 text-center">
    <h1 class="text-green-qaira font-weight-bolder">{{'about_us.trust_us' | translate}}</h1>
  </div>
  <div class="container text-center">
    <h4 class="font-weight-bolder">{{'about_us.customers' | translate}}</h4>
    <div class="mb-3">
      <carousel autoplay="true" transitionTimingFunction="ease-in-out" loop="true" autoplayInterval="2000"
        overflowCellsLimit="1">
        <div class="carousel-cell" *ngFor="let item of listClientsCarousel">
          <img [src]="item" alt="">
        </div>
      </carousel>
    </div>
    <h4 class="font-weight-bolder">{{'about_us.partners' | translate}}</h4>
    <div>
      <carousel overflowCellsLimit="3" transitionTimingFunction="ease-in-out" autoplay="true" loop="true"
        autoplayInterval="2000">
        <div class="carousel-cell" *ngFor="let item of listAliancesCarousel">
          <img [src]="item" alt="">
        </div>
      </carousel>
    </div>
  </div>
</section>
<section>
  <div class="py-4 bg-blue-qaira">
    <h3 class="text-center text-white font-weight-bolder">{{'about_us.awards' | translate}}</h3>
  </div>
  <div class="container">
    <div class="row timeline-web">
      <!--- AAAA --->
      <div class="col-lg-6 border-timeline">
        <div class="card item-timeline-left mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2023</b></p>
                <p class="">{{'about_us.2023_3' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-left mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2023</b></p>
                <p class="">{{'about_us.2023_1' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-left mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2022</b></p>
                <p class="">{{'about_us.2022_3' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-left mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2022</b></p>
                <p class="">{{'about_us.2022_1' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-left mt-6">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-right">
                <p class="text-blue-qaira font-large"><b>2021</b></p>
                <p class="">{{'about_us.2021_2' | translate}} </p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-left mt-6">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-right">
                <p class="text-blue-qaira font-large"><b>2020</b></p>
                <p class="">{{'about_us.2020_2' | translate}} </p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-left mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-right">
                <p class="text-blue-qaira font-large"><b>2020</b></p>
                <p class="">{{'about_us.2020_4' | translate}} </p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-left mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-right">
                <p class="text-blue-qaira font-large"><b>2019</b></p>
                <p class="">{{'about_us.2019_2' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-left mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-right">
                <p class="text-blue-qaira font-large"><b>2018</b></p>
                <p class="">{{'about_us.2018_2' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-left mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-right">
                <p class="text-blue-qaira font-large"><b>2018</b></p>
                <p class="">{{'about_us.2018_4' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-left mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-right">
                <p class="text-blue-qaira font-large"><b>2016</b></p>
                <p class="">{{'about_us.2016_1' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-left mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-right">
                <p class="text-blue-qaira font-large"><b>2016</b></p>
                <p class="">{{'about_us.2016_3' | translate}}</p>
              </div>
            </div>
          </div>
        </div>


      </div>
      <!--- BBBB --->
      <div class="col-lg-6">
        <div class="card item-timeline-right mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2023</b></p>
                <p class="">{{'about_us.2023_2' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-right mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2022</b></p>
                <p class="">{{'about_us.2022_5' | translate}}<br><br><br><br></p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-right mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2022</b></p>
                <p class="">{{'about_us.2022_4' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-right mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2022</b></p>
                <p class="">{{'about_us.2022_2' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-right mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2021</b></p>
                <p class="">{{'about_us.2021_1' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-right mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2020</b></p>
                <p class="">{{'about_us.2020_1' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-right mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2020</b></p>
                <p class="">{{'about_us.2020_5' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-right mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2020</b></p>
                <p class="">{{'about_us.2020_3' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-right mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2019</b></p>
                <p class="">{{'about_us.2019_1' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-right mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2018</b></p>
                <p class="">{{'about_us.2018_1' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-right mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2018</b></p>
                <p class="">{{'about_us.2018_3' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-right mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2017</b></p>
                <p class="">{{'about_us.2017_1' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-right mt-5">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2016</b></p>
                <p class="">{{'about_us.2016_2' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card item-timeline-right mt-3">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 text-left">
                <p class="text-blue-qaira font-large"><b>2015</b></p>
                <p class="">{{'about_us.2015_1' | translate}}</p>
              </div>
            </div>
          </div>
        </div>



      </div>
    </div>
    <div class="row timeline-mobile">
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2023</b></p>
              <p class="">{{'about_us.2023_1' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2023</b></p>
              <p class="">{{'about_us.2023_2' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2023</b></p>
              <p class="">{{'about_us.2023_3' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2022</b></p>
              <p class="">{{'about_us.2022_5' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2022</b></p>
              <p class="">{{'about_us.2022_4' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2022</b></p>
              <p class="">{{'about_us.2022_3' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2022</b></p>
              <p class="">{{'about_us.2022_2' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2022</b></p>
              <p class="">{{'about_us.2022_1' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <!---- *********************** -->
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2021</b></p>
              <p class="">{{'about_us.2021_1' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2021</b></p>
              <p class="">{{'about_us.2021_2' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2020</b></p>
              <p class="">{{'about_us.2020_1' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2020</b></p>
              <p class="">{{'about_us.2020_2' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2020</b></p>
              <p class="">{{'about_us.2020_3' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2020</b></p>
              <p class="">{{'about_us.2020_4' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2019</b></p>
              <p class="">{{'about_us.2019_1' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2019</b></p>
              <p class="">{{'about_us.2019_2' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2018</b></p>
              <p class="">{{'about_us.2018_1' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2018</b></p>
              <p class="">{{'about_us.2018_2' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2018</b></p>
              <p class="">{{'about_us.2018_3' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2018</b></p>
              <p class="">{{'about_us.2018_4' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2017</b></p>
              <p class="">{{'about_us.2017_1' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2016</b></p>
              <p class="">{{'about_us.2016_1' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2016</b></p>
              <p class="">{{'about_us.2016_2' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2016</b></p>
              <p class="">{{'about_us.2016_3' | translate}} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="text-blue-qaira font-large"><b>2015</b></p>
              <p class="">{{'about_us.2015_1' | translate}} </p>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</section>